 export const baseURL = "https://dev.api.qtradeview.com" // development/staging
//
// export const baseURL = "https://localhost:7261";
export const secureEndPoint = "api/secure";
export const publicEndpoint = "api/public";
export const generalEndpoint = "api";

// Google OAuth Client ID for Q AI
export const GOOGLE_CLIENT_ID = "282730540818-q9195uu434157psduf2qt2cg1bf30rj3.apps.googleusercontent.com";
